module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    model: {
      value: (_vm.isVisible),
      callback: function($$v) {
        _vm.isVisible = $$v
      },
      expression: "isVisible"
    }
  }, [_c('div', {
    staticClass: "c-modalCard"
  }, [_c('header', {
    staticClass: "c-modalCard__header"
  }, [_c('h4', {
    staticClass: "c-modalCard__title"
  }, [_vm._v("Confirmar da ação de reprocessar imagens de produtos")]), _vm._v(" "), _c('a', {
    staticClass: "c-modalCard__close",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        _vm.isVisible = false
      }
    }
  }, [_c('i', {
    staticClass: "i-remove"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "c-modalCard__body"
  }, [_vm._v("\n      Reprocessar imagens pode sobrecarregar a capacidade da sua fila de processamento e\n      com isso gerar atraso na comunicação com o marketplace.\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "c-modalCard__body"
  }, [_vm._v("\n      Tem certeza de que deseja Reprocessar as imagens do produto " + _vm._s(_vm.productInText) + "?\n    ")]), _vm._v(" "), _c('footer', {
    staticClass: "c-modalCard__footer"
  }, [_c('button', {
    staticClass: "btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.cancel()
      }
    }
  }, [_vm._v("Não")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn--success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.confirm()
      }
    }
  }, [_vm._v("Sim")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-48f73f1b","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/marketplace/shared/ModalReprocessImages.vue
// module id = 3123
// module chunks = 0